// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"647":"8547b015","684":"3aa8f274"}[chunkId] + ".chunk.css";
};